import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import { i18n } from '../../../../language';
import { alertMsg } from '../../../../apis/commlogic';
import Header from './head';
import Select from './select';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  title: {
    padding: '0.563rem 0 0.563rem 1.25rem',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginBottom: '0.688rem',
  },
  select: {
    display: 'flex',
  },
  foot: {
    marginLeft: '3.438rem',
    marginBottom: '0.875rem',
  },
  ConfirmBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    backgroundColor: '#4c93ff',
    justifyContent: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    marginBottom: '0.875rem',
  },
}));

export default function Time({ backOnclick, handleConfirm }) {
  const classes = useStyles();
  const [startTime, setStartTime] = useState(moment());
  const [endTime, setEndTime] = useState(moment(startTime).add(8, 'h'));
  const [startHour, setStartHour] = useState(moment(startTime).format('h'));
  const [startMin, setStartMin] = useState(moment(startTime).format('mm'));
  const [startAMPM, setStartAMPM] = useState(moment(startTime).format('a'));
  const [endHour, setEndHour] = useState(moment(startTime).format('h'));
  const [endMin, setEndMin] = useState(moment(startTime).format('mm'));
  const [endAMPM, setEndAMPM] = useState(moment(startTime).format('a'));

  useEffect(() => {
    setStartTime(moment(`${startHour}:${startMin} ${startAMPM}`, 'hh:mm aa'));
  }, [startHour, startMin, startAMPM]);
  useEffect(() => {
    setEndTime(moment(`${endHour}:${endMin} ${endAMPM}`, 'hh:mm aa'));
  }, [endHour, endMin, endAMPM]);

  return (
    <div className={classes.root}>
      <div>
        <Header backOnclick={backOnclick} id="DutyAssign-Header-act" title={i18n.t('DUTYASSIGN_ROSTER_FILTER_TIME')} />
        <div className={classes.title}>{i18n.t('DUTYASSIGN_ROSTER_ADD_START_TITLE')}</div>
        <div className={classes.select}>
          <Select
            readOnly={false}
            onBlur={(e) => {
              let hour = e.target.value.replace(/\D/g, '');
              if (e.target.value > 12) {
                hour = 12;
              } else if (e.target.value < 1 || hour === '') {
                hour = 1;
              }
              setStartHour(hour);
            }}
            id="DutyAssign-Select-hour-acu"
            onChange={(e) => {
              setStartHour(e.target.value);
            }}
            value={startHour}
            handleAdd={() => {
              let hour = parseInt(startHour) + 1;
              if (hour > 12) hour = 1;
              setStartHour(hour);
            }}
            handleReduck={() => {
              let hour = parseInt(startHour) - 1;
              if (hour < 1) hour = 12;
              setStartHour(hour);
            }}
          />
          <Select
            readOnly={false}
            onBlur={(e) => {
              let min = e.target.value.toString().replace(/\D/g, '');
              if (min > 59) min = 59;
              else if (min < 0 || min === '') min = '00';
              if (min.length < 2) min = `0${min}`;
              setStartMin(min);
            }}
            onChange={(e) => {
              let min = e.target.value;
              setStartMin(min);
            }}
            id="DutyAssign-Select-minute-acv"
            value={startMin}
            handleAdd={() => {
              let min = parseInt(startMin) + 1;
              if (min > 59) min = 0;
              if (min < 10) min = `0${min}`;
              setStartMin(min);
            }}
            handleReduck={() => {
              let min = parseInt(startMin) - 1;
              if (min < 0) min = 59;
              if (min < 10) min = `0${min}`;
              setStartMin(min);
            }}
          />
          <Select
            value={startAMPM}
            handleAdd={() => {
              setStartAMPM(startAMPM === 'am' ? 'pm' : 'am');
            }}
            id="DutyAssign-Select-acw"
            handleReduck={() => {
              setStartAMPM(startAMPM === 'am' ? 'pm' : 'am');
            }}
          />
        </div>
        <div className={classes.title}>{i18n.t('DUTYASSIGN_ROSTER_ADD_END_TITLE')}</div>
        <div className={classes.select} style={{ borderBottom: '0.0625rem solid #e4e7eb' }}>
          <Select
            readOnly={false}
            onBlur={(e) => {
              let hour = e.target.value.replace(/\D/g, '');
              if (e.target.value > 12) {
                hour = 12;
              } else if (e.target.value < 1 || hour === '') {
                hour = 1;
              }
              setEndHour(hour);
            }}
            id="DutyAssign-Select-hour-acx"
            onChange={(e) => {
              setEndHour(e.target.value);
            }}
            value={endHour}
            handleAdd={() => {
              let hour = parseInt(endHour) + 1;
              if (hour > 12) hour = 1;
              setEndHour(hour);
            }}
            handleReduck={() => {
              let hour = parseInt(endHour) - 1;
              if (hour < 1) hour = 12;
              setEndHour(hour);
            }}
          />
          <Select
            readOnly={false}
            onBlur={(e) => {
              let min = e.target.value.replace(/\D/g, '');
              if (min > 59) min = 59;
              else if (min < 0 || min === '') min = '00';
              if (min.length < 2) min = `0${min}`;
              setEndMin(min);
            }}
            id="DutyAssign-Select-minute-acy"
            onChange={(e) => {
              let min = e.target.value;
              setEndMin(min);
            }}
            value={endMin}
            handleAdd={() => {
              let min = parseInt(endMin) + 1;
              if (min > 59) min = 0;
              if (min < 10) min = `0${min}`;
              setEndMin(min);
            }}
            handleReduck={() => {
              let min = parseInt(endMin) - 1;
              if (min < 0) min = 59;
              if (min < 10) min = `0${min}`;
              setEndMin(min);
            }}
          />
          <Select
            value={endAMPM}
            handleAdd={() => {
              setEndAMPM(endAMPM === 'am' ? 'pm' : 'am');
            }}
            id="DutyAssign-Select-acz"
            handleReduck={() => {
              setEndAMPM(endAMPM === 'am' ? 'pm' : 'am');
            }}
          />
        </div>
      </div>
      <div className={classes.foot}>
        <ButtonBase
          className={classes.ConfirmBtn}
          onClick={() => {
            if (moment(startTime).format('HHmm') > moment(endTime).format('HHmm')) {
              alertMsg(i18n.t('DUTYASSIGN_ROSTER_TIME_RANGE_ERROR'), _.uniqueId('warning_'), 'warning');
              return;
            }
            handleConfirm(moment(startTime).format('HHmm'), moment(endTime).format('HHmm'));
          }}
          id="DutyAssign-ButtonBase-acz"
          style={{ opacity: moment(startTime).format('HHmm') > moment(endTime).format('HHmm') ? 0.2 : 1 }}
        >
          {i18n.t('DUTYASSIGN_ROSTER_FILTER_GROUP_CONFIRM')}
        </ButtonBase>
      </div>
    </div>
  );
}
